const YM_ID = 106929702

type YmFn = (id: number, action: string, target?: string, params?: Record<string, unknown>) => void

export function reachGoal(target: string, params?: Record<string, unknown>) {
  const ym = (window as unknown as { ym?: YmFn }).ym
  if (typeof ym === 'function') {
    ym(YM_ID, 'reachGoal', target, params)
  }
}

/** Просмотр страницы без перезагрузки (переходы внутри сайта счётчик сам не видит). referer — откуда пришли. */
export function pageHit(url: string, referer?: string) {
  const ym = (window as unknown as { ym?: YmFn }).ym
  if (typeof ym === 'function') {
    ym(YM_ID, 'hit', url, referer ? { referer } : undefined)
  }
}
